import * as React from 'react';
import { FaTimes } from 'react-icons/fa';
import ContactForm from './ContactForm';

interface PromoBannerProps {
  onClose?: () => void;
}

const PromoBanner: React.FC<PromoBannerProps> = ({ onClose }) => {
  const [isVisible, setIsVisible] = React.useState(true);
  const handleClose = () => {
    setIsVisible(false);
    if (onClose) onClose();
  };


  if (!isVisible) return null;

  return (
    <>
      <div style={{
        backgroundColor: '#E0FFFF',
        color: '#36454F',
        padding: '6px 0',
        position: 'relative',
        textAlign: 'center',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '13px',
      }}>
        <div style={{ 
          maxWidth: '1200px', 
          margin: '0 auto', 
          padding: '0 20px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: '100%',
        }}>
          <span style={{ fontWeight: 'bold', marginRight: '8px' }}>🔥 Attn Amazon Agencies: Only 5 More Seats Left for Our Exclusive AI Command Center! 🔥</span>
          <a
            href="https://cortexiqbeta.sellersynapse.com/" 
            target="_blank"
            rel="noopener noreferrer"
            style={{
              backgroundColor: '#ff5722',
              color: 'white',
              padding: '4px 10px',
              borderRadius: '4px',
              marginLeft: '16px',
              textDecoration: 'none',
              fontWeight: 'bold',
              boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)',
              transition: 'all 0.2s ease',
              border: '2px solid #36454F',
            }}
            onMouseOver={(e) => {
              e.currentTarget.style.backgroundColor = '#ff7043';
              e.currentTarget.style.transform = 'translateY(-2px)';
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.backgroundColor = '#ff5722';
              e.currentTarget.style.transform = 'translateY(0)';
            }}
          >
            Join Now - Get Access
          </a>
        </div>
        <button
          onClick={handleClose}
          style={{
            background: 'none',
            border: 'none',
            color: '#36454F',
            cursor: 'pointer',
            position: 'absolute',
            right: '10px',
            top: '50%',
            transform: 'translateY(-50%)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '5px',
          }}
          aria-label="Close banner"
        >
          <FaTimes />
        </button>
      </div>
    </>
  );
};

export default PromoBanner;
